/*
  Collection of utility methods to validate entities.
  e.g. emails
*/

class Validator {
  static isEmail(text) {
    return /^.+@.+\..+$/.test(text);
  }

  static passwordIsValid(text) {
    return /^.{6}.*$/.test(text);
  }

  static isRUT(text) {
    return /^\d{12}$/.test(text);
  }

  static isPhone(text) {
    const phone = /^((09[1-9]([0-9]{3})([0-9]{3}))|((2|4)([0-9]{3})([0-9]{2})([0-9]{2})))$/g;
    return phone.test(text);
  }

  static isUruguayanId(text) {
    let newText = text.replace(/\D/g, '');
    const dig = parseInt(newText[newText.length - 1], 0);
    let a = 0;
    let i = 0;
    if (text.length <= 6) {
      for (i = text.length; i < 7; i += 1) {
        newText = `0${text}`;
      }
    }
    for (i = 0; i < 7; i += 1) {
      a += (parseInt('2987634'[i], 0) * parseInt(text[i], 0)) % 10;
    }
    if (a % 10 === 0) {
      return dig === 0;
    }
    return dig === 10 - (a % 10);
  }

  static isUruguayanRUT(text) {
    // eslint-disable-next-line no-restricted-globals
    if (text.length !== 12 || !/^\d+$/.test(text)) {
      return false;
    }
    const dc = text.substr(11, 1);
    const rut = text.substr(0, 11);
    let total = 0;
    let factor = 2;
    for (let i = 10; i >= 0; i -= 1) {
      total += factor * rut.substr(i, 1);
      // eslint-disable-next-line no-plusplus
      factor = factor === 9 ? 2 : ++factor;
    }
    let dv = 11 - (total % 11);
    if (dv === 11) {
      dv = 0;
    } else if (dv === 10) {
      dv = 1;
    }
    return dv.toString() === dc.toString();
  }

  static isUruguayanRUTNew(text) {
    const rut = text.trim();
    if (rut.length !== 12) return false;

    const prefix = parseInt(rut.slice(0, 2), 10);
    if (prefix < 1 || prefix > 22 || rut.slice(2, 8) === '000000' || rut.slice(8, 10) !== '00') {
      return false;
    }

    const checkDigit = parseInt(rut.slice(-1), 10);
    const baseDigits = rut.slice(0, 11);

    let sum = 0;
    let multiplier = 2;

    // eslint-disable-next-line no-plusplus
    for (let i = baseDigits.length - 1; i >= 0; i--) {
      sum += parseInt(baseDigits[i], 10) * multiplier;
      multiplier = (multiplier === 9) ? 2 : multiplier + 1;
    }

    const result = 11 - (sum % 11);

    // Check if the result matches the expected check digit
    if (result === 10) return false; // Discard result 10
    if (result === 11) return checkDigit === 0;

    return checkDigit === result;
  }
}

export { Validator };



// WEBPACK FOOTER //
// ./src/helpers/Validator.js